// Export scope resolution shared by the Actions menu label and cabinetCsvExportRequestBehavior,
// so the label always describes what the export will actually produce.

export const EXPORT_SCOPE_ALL = 'all';
export const EXPORT_SCOPE_FILTERED = 'filtered';
export const EXPORT_SCOPE_SELECTION = 'selection';

// Present on every cabinet index query regardless of what the user does, so they do not
// count as the user narrowing the view.
const STRUCTURAL_FILTER_KEYS = ['cabinetIdentifier', 'formTypeIdentifiers'];

/**
 *  metaDeleted rides along on every index query as 0, so it is only a narrowing filter in the
 *  deleted-forms view. Export does scope to deleted rows there, and the label has to say so.
 */
const isDefaultMetaDeleted = (key, value) => key === 'metaDeleted' && !Number(value);
const isEmptyFilterValue = value => {
  if (value === null || value === undefined || value === '') {
    return true;
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  return false;
};
export const collectExportSelectionIds = (selection = {}) => {
  const ids = Object.values(selection || {}).reduce((acc, formTypeIds) => acc.concat(Array.isArray(formTypeIds) ? formTypeIds : []), []);
  return [...new Set(ids.filter(Boolean))];
};
export const hasActiveCabinetFilters = (filters = {}) => Object.entries(filters || {}).some(([key, value]) => !STRUCTURAL_FILTER_KEYS.includes(key) && !isDefaultMetaDeleted(key, value) && !isEmptyFilterValue(value));

/**
 *  Selected ids that are actually resolvable to rows in the current cabinet page.
 *
 *  Bulk behaviors resolve selection against the loaded cabinet list, so ids left selected on
 *  a previously viewed page are dropped before export. Counting them the same way keeps the
 *  menu label from promising more rows than the export delivers.
 */
export const resolveExportSelectionIds = (selected = [], cabinetList = []) => {
  const listIds = new Set((cabinetList || []).map(row => row === null || row === void 0 ? void 0 : row.id));
  const resolved = (selected || []).filter(id => listIds.has(id));
  return Array.from(new Set(resolved));
};
export const resolveExportScope = ({
  selectionCount: _selectionCount = 0,
  filters: _filters = {}
} = {}) => {
  if (_selectionCount > 0) {
    return EXPORT_SCOPE_SELECTION;
  }
  if (hasActiveCabinetFilters(_filters)) {
    return EXPORT_SCOPE_FILTERED;
  }
  return EXPORT_SCOPE_ALL;
};
export const buildExportMenuTitle = ({
  selectionCount: _selectionCount2 = 0,
  filters: _filters2 = {}
} = {}) => {
  const scope = resolveExportScope({
    selectionCount: _selectionCount2,
    filters: _filters2
  });
  if (scope === EXPORT_SCOPE_SELECTION) {
    return `Export Selected (${_selectionCount2})`;
  }
  if (scope === EXPORT_SCOPE_FILTERED) {
    return 'Export Filtered';
  }
  return 'Export All';
};
export default resolveExportScope;